import { environment } from "../../../environments/environment";

export const SECURITY = {
  AUTHORIZATION_BASIC: {
    BEFORE_LOGIN: environment.authorizationApiToken_BEFORE,
    AFTER_LOGIN: environment.authorizationApiToken_AFTER
  }
};

export const API_CHAT_MESSAGES_URL = {
  GET_CHAT_MESSSAGES: {
    path: '/chatMessages/{attendantId}',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  GET_CHAT_FILE: {
    path: '/chatMessages/{attendantId}/{fileId}',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      },
      fileId: {
        key: 'fileId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  POST_CHAT_MESSSAGES: {
    path: '/chatMessages',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      },
      message: {
        key: 'message',
        value: ''
      },
      file: {
        key: 'file',
        value: ''
      },
      fileType: {
        key: 'fileType',
        value: ''
      },
      fileName: {
        key: 'fileName',
        value: ''
      },
      name: {
        key: 'name',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  }
};
